import React, { useContext } from 'react';
import './ServiceBanner.scss';
import { Link } from 'react-router-dom';
import { LanguageContext } from '../../context/LanguageContext';
import serviceBanner from '../../assets/servicePage/1.png';

const ServiceBanner = () => {
    const { t } = useContext(LanguageContext);

    return (
        <section className='service-banner-section section-common section-bg'>
            <div className="d-table">
                <div className="d-table-cell">
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="col-lg-5 col-md-6">
                                <div className="service-banner-text" data-aos="fade-up" data-aos-duration="1500" data-aos-once="true" data-aos-offset="100">
                                    <h1>{t('dentalSymptoms.title')}</h1>
                                    <p>{t('dentalSymptoms.description')}</p>
                                    <div className="theme-btn">
                                        <Link to="/">{t('appointment.form.button')}</Link>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-7 col-md-6">
                                <div className="service-banner-img" data-aos="fade-up" data-aos-duration="1500" data-aos-once="true" data-aos-offset="100">
                                    <img src={serviceBanner} alt={t('altText.service')} />
                                </div>
                            </div>
                        </div>
                        
                        <div className="row mt-5">
                            {t('dentalSymptoms.symptoms').map((symptom, index) => (
                                <div key={index} className="col-md-6 mb-4">
                                    <div className="symptom-card d-flex align-items-center">
                                        <div className="icon me-3">
                                            <img src={require('../../assets/banner/icons/Calling.png')} alt={symptom.title} />
                                        </div>
                                        <div className="content">
                                            <h4>{symptom.title}</h4>
                                            <p>{symptom.description}</p>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ServiceBanner;